export const SCALE = [
    {
        country: "Argentina",
        keywords: [],
        price: 0.102
    },
    {
        country: "Brazil",
        keywords: [],
        price: 0.103
    },
    {
        country: "Chile",
        keywords: [],
        price: 0.136
    },
    {
        country: "Colombia",
        keywords: [],
        price: 0.041
    },
    {
        country: "Egypt",
        keywords: [],
        price: 0.159
    },
    {
        country: "France",
        keywords: [],
        price: 0.204
    },
    {
        country: "Germany",
        keywords: [],
        price: 0.196
    },
    {
        country: "India",
        keywords: [],
        price: 0.038
    },
    {
        country: "Indonesia",
        keywords: [],
        price: 0.076
    },
    {
        country: "Israel",
        keywords: [],
        price: 0.069
    },
    {
        country: "Italy",
        keywords: [],
        price: 0.111
    },
    {
        country: "Malaysia",
        keywords: [],
        price: 0.132
    },
    {
        country: "Mexico",
        keywords: [],
        price: 0.079
    },
    {
        country: "Netherlands",
        keywords: [],
        price: 0.225
    },
    {
        country: "Nigeria",
        keywords: [],
        price: 0.09
    },
    {
        country: "Pakistan",
        keywords: [],
        price: 0.084
    },
    {
        country: "Peru",
        keywords: [],
        price: 0.113
    },
    {
        country: "Russia",
        keywords: [],
        price: 0.125
    },
    {
        country: "Saudi Arabia",
        keywords: [],
        price: 0.082
    },
    {
        country: "South Africa",
        keywords: [],
        price: 0.072
    },
    {
        country: "Spain",
        keywords: [],
        price: 0.102
    },
    {
        country: "Turkey",
        keywords: [],
        price: 0.039
    },
    {
        country: "United Arab Emirates",
        keywords: [],
        price: 0.073
    },
    {
        country: "United Kingdom",
        keywords: [
           "ngland",
            "northern ireland",
            "scotland",
            "wales"
        ],
        "price": 0.091
    },
    {
        country: "North America",
        keywords: [
           "nited states, usa, canada"
        ],
        "price": 0.056
    },
    {
        country: "Rest of Africa",
        keywords: [],
        price: 0.053
    },
    {
        country: "Rest of Asia Pacific",
        keywords: [],
        price: 0.117
    },
    {
        country: "Rest of Central & Eastern Europe",
        keywords: [],
        price: 0.132
    },
    {
        country: "Rest of Latin America",
        keywords: [],
        price: 0.118
    },
    {
        country: "Rest of Middle East",
        keywords: [],
        price: 0.068
    },
    {
        country: "Rest of Western Europe",
        keywords: [],
        price: 0.099
    },
    {
        country: "Other",
        keywords: [],
        price: 0.1
    }
];